import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {UpdateUserNewsletterResultModal} from './update-user-newsletter.result.modal';
import {
    clearResult,
    selectUpdateNewslettersBulkUuid,
    selectUpdateNewslettersShown,
    selectUpdateNewslettersTask,
} from './update-user-newsletter.slice';


export const UpdateUserNewsletterResult = () => (
    <BulkActionResult
        actionIdSelector={selectUpdateNewslettersBulkUuid}
        actionTaskSelector={selectUpdateNewslettersTask}
        actionShownSelector={selectUpdateNewslettersShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <UpdateUserNewsletterResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
